import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { apiFetch } from '../api';
import EditTenantPanel from './EditTenantPanel';
import Users from './Users';
import LoadingState from '../components/LoadingState';

// One customer's own page (it replaces the old "Rediger tenant" pop-up): what we know about the customer, the people who have access,
// the licence and the connections, and the way into the customer's portal.
export default function CustomerPage() {
  const { tenantId: routeId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orgId = searchParams.get('org');
  const orgName = searchParams.get('orgName');
  const tab = ['gen', 'usr', 'lic', 'con'].includes(searchParams.get('tab')) ? searchParams.get('tab') : 'usr';
  const [tenant, setTenant] = useState(null);
  const [overview, setOverview] = useState(null);
  const [error, setError] = useState('');

  async function load() {
    try {
      const res = await apiFetch(`/api/tenants${orgId ? `?orgId=${orgId}` : ''}`);
      const data = await res.json();
      if (!Array.isArray(data)) throw new Error('Kunden kunne ikke hentes');
      const found = data.find((t) => t.id === routeId || t.tenantId === routeId);
      if (!found) throw new Error('Kunden findes ikke, eller du har ikke adgang til den.');
      setTenant(found);
    } catch (err) {
      setError(err.message);
    }
    try {
      const res = await apiFetch(`/api/tenants-overview${orgId ? `?orgId=${orgId}` : ''}`);
      const data = await res.json();
      const mine = Array.isArray(data.tenants) ? data.tenants.find((t) => t.id === routeId) : null;
      setOverview(mine || null);
    } catch {
      // the connection chips just say "checking"
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeId, orgId]);

  const back = () => navigate(`/tenants${orgId ? `?org=${orgId}&orgName=${encodeURIComponent(orgName || '')}` : ''}`);

  if (error) {
    return (
      <div className="pu-page">
        <button type="button" className="pu-back" onClick={back}>Tilbage til kunder</button>
        <p className="state-error">{error}</p>
      </div>
    );
  }
  if (!tenant) return <LoadingState />;

  return (
    <EditTenantPanel
      asPage
      key={`${tenant.id}-${tab}`}
      tenant={tenant}
      overview={overview || undefined}
      initialTab={tab}
      backLabel={orgName ? `${orgName} · Kunde tenants` : 'Kunde tenants'}
      onClose={back}
      onSaved={load}
      onOpenPortal={() => navigate(`/tenant/${tenant.id}`)}
      portalHref={`/tenant/${tenant.id}`}
      usersSlot={<Users tenantScope={tenant.tenantId || tenant.id} tenantLabel={tenant.name} scopeOrgId={tenant.orgId || orgId} />}
    />
  );
}
